/** 对齐 ai-electron AudioFramePayload */
export interface AudioFramePayload {
  timestamp: number;
  rms: number;
  bass: number;
  mids: number;
  treble: number;
  spectrum: number[];
  beat?: boolean;
  source?: "system" | "microphone";
}

export interface KeyAnchor {
  provider: "xingshan" | "huafenda" | "beiying";
  row: number;
  col: number;
  layer: number;
  keyIndex?: number;
  value?: number;
  id?: number;
  system?: number;
}

export interface CanonicalKey {
  uuid: string;
  row: number;
  col: number;
  widthU: number;
  label: string;
  keyCode: number;
  defaultKeyCode: number;
  anchor: KeyAnchor;
  isGap?: boolean;
}

export function lightingPositionKey(row: number, col: number): string {
  return `${row},${col}`;
}
